var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sui-list", { staticClass: "sidebar-resource-item-list" }, [
    _c("div", { staticClass: "resource-item" }, [
      _c(
        "a",
        [
          _c(
            "router-link",
            { attrs: { to: { name: "complianceResourceList" } } },
            [_vm._v("Compliance")]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "resource-item" }, [
      _c(
        "a",
        [
          _c(
            "router-link",
            { attrs: { to: { name: "investmentsResourceList" } } },
            [_vm._v("Investments")]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "resource-item" }, [
      _c(
        "a",
        [
          _c(
            "router-link",
            { attrs: { to: { name: "operationsResourceList" } } },
            [_vm._v("Operations")]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "resource-item" }, [
      _c(
        "a",
        [
          _c("router-link", { attrs: { to: { name: "videosResourceList" } } }, [
            _vm._v("Videos"),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "resource-item" }, [
      _c(
        "a",
        [
          _c("router-link", { attrs: { to: { name: "faqs" } } }, [
            _vm._v("FAQs"),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }